module.exports = __webpack_public_path__ + "assets/147583c0928948e86aca1eb43628d6a0.mp3";